/* eslint-disable no-useless-catch */
import { isHttpStatusOK, parseFailed } from '@/apis/utils';
import { Auth } from '@/utils';

import { getEnv } from '@/utils';

const { GO_ENDPOINT, SITE_TYPE } = getEnv();

async function deleteUserCards(userId) {
  try {
    const token = await Auth.getIdToken();
    // 今は cardId 固定で運用します。
    const cardId = 1;

    const response = await fetch(
      `${GO_ENDPOINT}/v1/${SITE_TYPE}/users/${userId}/cards/${cardId}`,
      {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (isHttpStatusOK(response.status)) {
      return;
    }

    const responseJson = await response.json();
    throw new Error(parseFailed(responseJson.errors[0]));
  } catch (err) {
    throw err;
  }
}

export default deleteUserCards;
